import { render } from "./ModifyCategorieModal.vue?vue&type=template&id=39814208&ts=true"
import script from "./ModifyCategorieModal.ts?vue&type=script&lang=ts"
export * from "./ModifyCategorieModal.ts?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/RC.Estimatifs/rc-estimatifs-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__